import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import Tutorial from '../components/modal/tutorial';
import { modalState } from '../states/modalState';
import { userState } from '../states/userState';

const useTutorial = (): boolean => {
  const location = useLocation();
  const [{ userInfo }] = useRecoilState(userState);
  const [, setModalState] = useRecoilState(modalState);

  useEffect(() => {
    if (!userInfo) {
      return;
    }

    if (userInfo.terms_agreed_at === null) {
      setModalState({
        isOpen: true,
        component: <Tutorial />,
      });
    }
  }, [userInfo, location]);

  return;
};

export default useTutorial;
